var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#647A97",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.726 23.285a1 1 0 00-.168 1.993c1.269.093 2.53.268 3.776.523a.25.25 0 010 .488A39.97 39.97 0 0116 27a40.022 40.022 0 01-8.333-.711.25.25 0 010-.488 29.552 29.552 0 013.736-.52 1 1 0 00-.17-1.992C4 23.9 4 25.4 4 26.044 4 28.712 12.317 29 16 29s12-.288 12-2.956c0-.644 0-2.144-7.274-2.759z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6c.34 0 .658-.174.842-.461 1.958-3.063 6.512-10.536 6.512-13.786a7.355 7.355 0 00-14.71 0c0 3.25 4.554 10.724 6.513 13.786A.992.992 0 0016 26.6zM12.5 12a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
  })))));
}
export default SvgLocation;